import { useMemo, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { GALLERY, IMG } from "@/data/media";
import { PageHero } from "@/components/PageHero";
import { Lightbox } from "@/components/Lightbox";

const CATS = ["all", "people", "health", "volunteers", "projects", "architecture"];

export default function Gallery() {
  const { t } = useLang();
  const g = t.gallery;
  const [cat, setCat] = useState("all");
  const [idx, setIdx] = useState(null);
  const items = useMemo(
    () => GALLERY.filter((it) => cat === "all" || it.cat === cat).map((it) => ({ ...it, src: IMG[it.key], caption: g.captions[it.key] })),
    [cat, g]
  );
  return (
    <>
      <PageHero eyebrow={g.eyebrow} lines={g.titleLines} intro={g.intro} />
      <section className="pb-24 sm:pb-32" data-testid="gallery-section">
        <div className="wrap">
          <div className="flex flex-wrap gap-2" role="tablist" aria-label={g.eyebrow}>
            {CATS.map((c) => (
              <button key={c} role="tab" aria-selected={cat === c} onClick={() => setCat(c)} data-testid={`gallery-filter-${c}`} className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-colors duration-300 ${cat === c ? "bg-[var(--green-deep)] text-white" : "bg-white text-[var(--ink)] shadow-[inset_0_0_0_1px_var(--line)] hover:bg-[var(--yellow-pale)]"}`}>
                {c === "all" ? g.all : g.cats[c]}
              </button>
            ))}
          </div>
          <div className="masonry mt-10" data-testid="gallery-grid">
            {items.map((it, i) => (
              <motion.figure key={it.key} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: Math.min(i * 0.04, 0.4) }}>
                <button onClick={() => setIdx(i)} aria-label={`${g.open}: ${it.caption}`} className={`block w-full overflow-hidden img-zoom bg-white ${i % 3 === 0 ? "rounded-[2rem_2rem_2rem_0.4rem]" : "rounded-[1.5rem]"} shadow-[0_0_0_1px_var(--line)]`} data-testid={`gallery-item-${it.key}`}>
                  <img src={it.src} alt={it.caption} loading="lazy" className={`w-full h-auto ${it.cat === "architecture" ? "" : "photo"}`} />
                </button>
                <figcaption className="mt-2 px-1 flex justify-between gap-3 text-sm">
                  <span className="text-[var(--ink)]">{it.caption}</span>
                  <span className="text-[var(--ink-soft)] shrink-0">{g.cats[it.cat]}</span>
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </section>
      <Lightbox items={items} index={idx} onClose={() => setIdx(null)} onChange={setIdx} />
    </>
  );
}
